var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"EmailMembers"}},[_c('div',{staticClass:"page-header gold mt-4 mb-3"},[_c('back-btn'),_vm._m(0)],1),_c('tip-tap-editor',{attrs:{"editor_type":"default"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-envelope pr-2"}),_vm._v(" Email Members\n\t\t")])
}]

export { render, staticRenderFns }